import SpaceSizeEdit from "./SpaceSizeEdit";

export default SpaceSizeEdit;
